import { Injectable } from '@angular/core';
import {
  CheckTypeResponse,
  SectorCreateBody,
  SectorListItem,
  SectorListParams,
  SectorRepository,
  SectorTaskGroupings,
} from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { map, Observable } from 'rxjs';
import { SectorService } from '../api-clients';
import { SectorMapper } from '../mappers';

@Injectable()
export class SectorRepositoryImpl implements SectorRepository {
  private readonly _sectorMapper = new SectorMapper();

  constructor(private readonly _sectorService: SectorService) {}

  getSector(
    params: SectorListParams
  ): Observable<PaginatedResponse<SectorListItem>> {
    const SectorListItemDTO = this._sectorService.getSector(params);
    return SectorListItemDTO.pipe(
      map(dto => this._sectorMapper.sectorListToDomain(dto))
    );
  }

  getSectorDetail(id: number): Observable<SectorTaskGroupings> {
    const sectorDetailDTO = this._sectorService.getSectorDetail(id);
    return sectorDetailDTO.pipe(
      map(dto => this._sectorMapper.sectorDetailToDomain(dto))
    );
  }

  getSectorDetailEdit(id: number): Observable<SectorListItem> {
    const sectorDetailEditDTO = this._sectorService.getSectorDetailEdit(id);
    return sectorDetailEditDTO.pipe(
      map(dto => this._sectorMapper.sectorListItemToDomain(dto))
    );
  }

  checkSectorType(): Observable<CheckTypeResponse> {
    return this._sectorService.checkSectorType();
  }

  getBerthList(): Observable<any> {
    return this._sectorService.getBerthList();
  }

  getClientCodeList(): Observable<any> {
    return this._sectorService.getClientCodeList();
  }

  createSector(sectorData: SectorCreateBody): Observable<SectorCreateBody> {
    return this._sectorService.createSector(sectorData);
  }

  updateSector(id: number, sectorData: SectorCreateBody): Observable<void> {
    return this._sectorService.updateSector(id, sectorData);
  }

  updateStatus(sectorId: number, isActive: boolean): Observable<void> {
    return this._sectorService.updateStatus(sectorId, isActive);
  }
}
